import { HasOnComplete, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface PODDataModel {
    pod: PODData[];
    error: boolean;
    parameter: PODParameter;
}

export interface PODData {
    OrderNumber: string;
    OrderDate: string;
    DeliveryId: string;
    DriverName: string;
    DeliveryDate: string;
    GroupId: string;
    GroupName: string;
    LocationAddress: string;
    LocationCity: string;
    LocationKey: string;
    LocationPostalCode: string;
    LocationState: string;
    Name: string;
    DeliveryNotes: string;
    ReceivedBy: string;
    SignatureReceived: boolean;
    PODDataReceived: boolean;
    PreviousPodId: string;
    NextPodId: string;
    PODItems: PODItemResponse[];
    PODImages: PODImageResponse[];
}

export interface PODItemResponse {
    PODId: string;
    SKU: string;
    Description: string;
    Quantity: number;
}

export interface PODImageResponse {
    PODId: string;
    ImageType: string;
    Image: Uint8Array;
}

export interface PODDataResultModel {}

export interface PODParameter extends ApiParameter {
    id?: string;
    orderNumber?: string;
    // onError?: (error: string, statusCode?: number) => void;
}

const PODUrl = "api/v1/pod/podDetails";

export async function getPODData(
    parameter: PODParameter & HasOnSuccess<PODDataResultModel> & HasOnComplete<PODDataResultModel>,
) {
    const response = await get<PODDataModel>(`${PODUrl}?parameter=${parameter.orderNumber},${parameter.id}`);
    return response;
}
